import React, { useState, useRef, useContext, useEffect } from 'react';
import { Row, Container, Col, Label, Input, FormGroup } from 'reactstrap';
import classNames from 'classnames';
import styles from './VerifyCode.module.css';
import SimpleReactValidator from 'simple-react-validator';
import { Redirect } from 'react-router-dom';
import { SessionContext } from '../context/SessionContext';
import { ReactComponent as ShieldBackground } from '../assets/images/verify-code.svg';

const VerifyLogin = (props) => {
    const sessionContext = useContext(SessionContext);
    const validator = useRef(
        new SimpleReactValidator({
            element: (message) => <div className='errorMsg'>{message.charAt(0).toUpperCase() + message.slice(1)}</div>,
            messages: {
                required: ':attribute is required.'
            },
            validators: {
                invalid: {
                    message: `The verification code is invalid.`,
                    rule: (val) => {
                        return val === true;
                    }
                }
            }
        })
    );
    const [code, setCode] = useState('');
    const [invalid, setInvalid] = useState(false);
    const [codeErr, setCodeErr] = useState(true);
    const [verificationCode, setVerificationCode] = useState(Array(6).fill(''));
    const inputRefs = useRef([]);

    useEffect(() => {
        const isCompleteCode = verificationCode.every((code) => code !== '');
        isCompleteCode ? setCodeErr(false) : setCodeErr(true);
    }, [verificationCode]);

    const handleContinue = async () => {
        if (!codeErr) {
            if (sessionContext.getIsForgotPassword()) {
                let route = `authentication/VerifyUserToken`;
                var token = {
                    userFriendlyToken: verificationCode.join(''),
                    validateOnly: true
                };
                fetch(route, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(token)
                }).then((response) => {
                    //setIsSendEmailInProgress(false);
                    if (response.status === 200) {
                        response.json().then((data) => {
                            if (data) {
                                sessionContext.updateVerifyPassLink(false);
                                sessionContext.updateConfirmPassLink(true);
                                sessionContext.setIsForgotPassword(false);
                                props.history.push({
                                    pathname: '/confirmpassword',
                                    state: {
                                        code: verificationCode.join('')
                                    }
                                });
                            } else {
                                setCodeErr(true);
                                setInvalid(true);
                            }
                        });
                    } else if (response.status === 404) {
                        setCodeErr(true);
                        setInvalid(true);
                    } else if (response.status === 400) {
                        setCodeErr(true);
                        setInvalid(true);
                    }
                });
            } else {
                let route = `/authentication/CompleteLogin`;
                var model = {
                    UserFriendlyToken: verificationCode.join('')
                };
                const response = await fetch(route, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(model)
                }).then((response) => {
                    if (response.status === 200) {
                        response.json().then((data) => {
                            setInvalid(false);
                            setCodeErr(false);
                            window.location.replace(window.location.origin);
                        });
                    } else if (response.status === 401) {
                        setCodeErr(true);
                        setInvalid(true);
                    } else if (response.status === 400) {
                        setCodeErr(true);
                        setInvalid(true);
                    }
                });
            }
        }
    };

    const resendCode = () => {
        const emailId = props.location.state.emailId;
        const isForgotPassword = sessionContext.getIsForgotPassword();
        const route = isForgotPassword
            ? 'authentication/SendForgotPasswordCode'
            : '/authentication/SendVerificationCode';
        const model = isForgotPassword
            ? {
                  userEmail: emailId
              }
            : {
                  partyEmailId: emailId
              };
        fetch(route, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(model)
        }).then((response) => {
            if (response.status === 200) {
                setVerificationCode(Array(6).fill(''));
                setCodeErr(true);
                setInvalid(false);
            } else if (response.status === 404) {
            }
        });
    };

    const handleInputChange = (value, index) => {
        if (/^\d?$/.test(value)) {
            const newCode = [...verificationCode];
            newCode[index] = value;
            setVerificationCode(newCode);

            //Focus on new input field
            if (value && index < 5) {
                inputRefs.current[index + 1].focus();
                setCodeErr(true);
            } else {
                setCodeErr(false);
            }
            setInvalid(false);
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !verificationCode[index] && index > 0) {
            inputRefs.current[index - 1].focus();
            setCodeErr(true);
            setInvalid(false);
        }
    };

    if (!sessionContext.loginByEmailStatus) {
        return <Redirect to='/login' />;
    }

    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData('Text').slice(0, 6);
        const digits = pasteData.split('');
        const newCode = [...verificationCode];
        digits.forEach((digit, index) => {
            if (inputRefs.current[index]) {
                inputRefs.current[index].value = digit;
                newCode[index] = digit;
            }
        });
        setVerificationCode(newCode);
    };
    return (
        <div className={styles.vendorVerifyCode}>
            <ShieldBackground className={styles.shieldBackground} />
            <Container className={styles.mainContainer}>
                <Col
                    md='12'
                    lg='12'
                >
                    <Col
                        lg='6'
                        md='5'
                        className={classNames('p-0')}
                    >
                        <h1 className='h3'>Verify It's You</h1>
                    </Col>
                    <Col
                        lg='5'
                        md='5'
                        className={classNames('p-0', 'pb-3', styles.infoText)}
                    >
                        We are sending a verification code to your email. Please enter it below.
                    </Col>
                    <Col
                        lg='4'
                        md='5'
                        className={classNames('p-0', 'pb-3')}
                    >
                        <FormGroup
                            className={classNames(
                                (validator.current.message('the verification code', code, 'required') || invalid)
                                    && 'form-error'
                            )}
                        >
                            <label
                                for='verifyCode'
                                className='form-label'
                            >
                                Enter Code
                            </label>
                            <span
                                aria-hidden='true'
                                className='required-indicator'
                            >
                                *
                            </span>
                            <div style={{ display: 'flex', gap: '10px', height: '40px' }}>
                                {verificationCode.map((digit, index) => (
                                    <input
                                        name='verifyCode'
                                        type='text'
                                        key={index}
                                        maxLength='1'
                                        value={digit}
                                        onChange={(e) => handleInputChange(e.target.value, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        ref={(el) => (inputRefs.current[index] = el)}
                                        style={{
                                            height: '40px',
                                            width: '40px',
                                            textAlign: 'center',
                                            fontSize: '18px'
                                        }}
                                        onPaste={index === 0 ? handlePaste : undefined}
                                    />
                                ))}
                            </div>
                            {invalid && <div class='errorMsg'>The verification code is invalid or has expired.</div>}
                        </FormGroup>
                        <button
                            className={classNames('btn-primary')}
                            onClick={() => handleContinue()}
                            disabled={codeErr}
                        >
                            CONTINUE
                        </button>
                        <Col
                            md='12'
                            className={styles.resendCol}
                        >
                            <a
                                className={styles.resendLink}
                                onClick={() => resendCode()}
                            >
                                Resend Code
                            </a>
                        </Col>
                    </Col>
                </Col>
            </Container>
        </div>
    );
};
export default VerifyLogin;
